"use client";

import { useDrawers, DrawersWithBackdrop } from "./Drawers";
import { useUI } from "@/app/context/UIContext";
import QuizLoop from "./home/QuizLoop";
import { useEffect } from "react";

export default function HomeClient({
  userName = "Studente",
  userId,
}: {
  userName?: string;
  userId?: string;
}) {
  const {
    leftOpen, rightOpen, rightContent,
    openLeft, closeLeft, openDati, openDocs, openImpostazioni, closeRight,
  } = useDrawers();

  const { setTitle, setOnOpenLeft, setOnOpenDati, setOnOpenDocs, setOnOpenImpostazioni } = useUI();

  useEffect(() => {
    setTitle("");
    setOnOpenLeft(() => openLeft);
    setOnOpenDati(() => openDati);
    setOnOpenDocs(() => openDocs);
    setOnOpenImpostazioni(() => openImpostazioni);
    return () => {
      setTitle("");
      setOnOpenLeft(null);
      setOnOpenDati(null);
      setOnOpenDocs(null);
      setOnOpenImpostazioni(null);
    };
  }, [openLeft, openDati, openDocs, openImpostazioni,
      setTitle, setOnOpenLeft, setOnOpenDati, setOnOpenDocs, setOnOpenImpostazioni]);

  return (
    <>
      <DrawersWithBackdrop
        leftOpen={leftOpen}
        rightOpen={rightOpen}
        rightContent={rightContent}
        onCloseLeft={closeLeft}
        onCloseRight={closeRight}
        onSelectConversation={() => {}}
      />
      <QuizLoop />
    </>
  );
}